import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { DashboardHeaderComponent } from '../components/dashboard-header/dashboard-header.component';
import { MobileBottomNavComponent } from '../components/mobile-bottom-nav/mobile-bottom-nav.component';
import { Store } from '@ngrx/store';
import { selectAuthLoading } from '../../store/auth/auth.selectors';
import { LoadingOverlayComponent } from '../../shared/components/loading-overlay/loading-overlay.component';
import { MediaLibraryDialogComponent } from '../../shared/components/media-library-dialog/media-library-dialog.component';

@Component({
    selector: 'app-admin-layout',
    standalone: true,
    imports: [CommonModule, RouterOutlet, SidebarComponent, DashboardHeaderComponent, MobileBottomNavComponent, LoadingOverlayComponent, MediaLibraryDialogComponent],
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent {
    private store = inject(Store);
    loading$ = this.store.select(selectAuthLoading);
    mobileNavOpen = false;

    navigation = [
        {
            name: 'Overview',
            children: [
                { name: "Dashboard", href: "/admin/dashboard", icon: "layout-dashboard" },
            ]
        },
        {
            name: 'Properties',
            children: [
                { name: "Manage Properties", href: "/admin/properties", icon: "home" },
                { name: "Property Approvals", href: "/admin/property-approvals", icon: "clipboard-check" },
                { name: "Deleted Properties", href: "/admin/deleted/properties", icon: "trash-2" },
            ]
        },
        {
            name: 'Projects',
            children: [
                { name: "Manage Projects", href: "/admin/projects", icon: "building-2" },
                { name: "Project Approvals", href: "/admin/project-approvals", icon: "building-2" },
                { name: "Verify Projects", href: "/admin/projects/verify", icon: "shield-check" },
                { name: "Deleted Projects", href: "/admin/deleted/projects", icon: "trash-2" },
            ]
        },
        {
            name: 'Users',
            children: [
                { name: "Users", href: "/admin/users", icon: "users" },
                { name: "Audit Logs", href: "/admin/audit-logs", icon: "file-text" },
                { name: "Signup Links", href: "/admin/signup-links", icon: "link" },
                { name: "System Leads", href: "/admin/system-leads", icon: "share-2" },
                { name: "Identity Reviews", href: "/admin/identity-reviews", icon: "shield" },
                { name: "Leads", href: "/admin/leads", icon: "message-square" },
                { name: "Companies", href: "/admin/companies", icon: "building-2" },
            ]
        },
        {
            name: 'Settings',
            children: [
                { name: "Prod To Dev Sync", href: "/admin/prod-to-dev-sync", icon: "database" },
                { name: "System Features", href: "/admin/system-features", icon: "sliders-horizontal" },
                { name: "Reservation Template", href: "/admin/reservation-template", icon: "file-text" },
                { name: "Features", href: "/admin/features", icon: "star" },
                { name: "FAQs", href: "/admin/faqs", icon: "book" },
                { name: "Notifications", href: "/admin/notifications", icon: "bell" },
                { name: "Legal Policies", href: "/admin/legal-policies", icon: "file-text" }
            ]
        }
    ];
}
